import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { startQuiz } from '../../store/actions/appstate';
import { LoginStates, setRoomCode, startAvatarSelection, resetBiosInput, setUserName } from '../../store/actions/login';


import BiosInput from './BiosInput/BiosInput';
import CodeLogin from './CodeLogin/CodeLogin';
import SocialLogin from './SocialLogin/SocialLogin';
import QuestionDevice from '../Quiz/QuestionDevice/QuestionDevice';
import NameInput from './NameInput/NameInput';

import SocketAPI from "../../../services/socketAPI";
import WakeLockService from "../../../services/WakeLockService";
export class Login extends Component {

    constructor(props) {
        super(props)
        this.selectAvatar = this.selectAvatar.bind(this);
        this.loginCallback = this.loginCallback.bind(this);
        this.roomChangeHandler = this.roomChangeHandler.bind(this);
        this.getAvatarOptions = this.getAvatarOptions.bind(this);
        this.enterName = this.enterName.bind(this);
    }

    /**
     * selectAvatar - Called when avatar is selected. It sends the info to the server, and renders next page
     * @param {event} e click event of Avatar selection 
     */
    selectAvatar(e) {		
        // console.log("Avatar:", e, this.props.avatars[e.id], this.props.roomCode);
        SocketAPI.setPlayerName(this.props.roomCode, this.props.avatars[e.id]);
        this.props.startQuiz();
        WakeLockService.enable();
        this.props.history.push('/quiz')
    }

    enterName(name, code) {
        if (code !== null) {
            console.log('code is set, so only join the quiz');
            this.props.setRoomCode(code)
            this.props.setUserName(name)
            SocketAPI.joinQuiz(code);
            WakeLockService.enable();
            SocketAPI.setRoomJoinedHandler(() => {
                console.log('room joined handler!');
                SocketAPI.setPlayerName(code, name, true);
                this.props.startQuiz();
                this.props.history.push('/quiz')
            });
        }else {
            SocketAPI.setPlayerName('4262', name, true);
            this.props.startQuiz();
            WakeLockService.enable();
            this.props.history.push('/quiz')        
        }
    }

    /**
     * roomChangeHandler - Called once the room has changed
     * @param {NUMBER} roomCode code of the room 
     */
    roomChangeHandler(roomCode) {
        this.props.setRoomCode(roomCode)
        SocketAPI.joinQuiz(roomCode);
    }

    /**
     * loginCallback - Called when login is done
     */
    loginCallback() {
        // If avatar selection is turned on, open that, otherwise start the quiz
        if (this.props.avatarSelectionEnabled) {
            this.props.startAvatarSelection()
        }else {
            this.props.startQuiz();
            this.props.history.push('/quiz')
        }
    }

    /**
     * getAvatarOptions - returns the possible avatars
     */
    getAvatarOptions() {
        const answers = this.props.avatars.map((a, index) => { return { id: index, answer: a } });
        return { question: "ALS WIE WIL JE SPELEN?", answer: "NOT EMPTY", Answers: answers };    
    }

	render() {
        // console.log('loginState=', this.props.currentLoginStep, this.biosReset)
        let currentScreen;
        console.log('current login step:', this.props.currentLoginStep)
        if (this.props.currentLoginStep === LoginStates.BIOS) {
            currentScreen = <BiosInput roomChangeHandler={this.roomChangeHandler}/>
        }else if (this.props.currentLoginStep === LoginStates.USERNAME) {
            currentScreen = <NameInput enterName={this.enterName} roomCode={this.roomCode}/>           
        }else if (this.props.currentLoginStep === LoginStates.CODE_LOGIN) {
            currentScreen = <CodeLogin/>
        }else if (this.props.currentLoginStep === LoginStates.SOCIAL_HOME) {
            currentScreen = <SocialLogin loginCallback={this.loginCallback}/>
        }else if (this.props.currentLoginStep === LoginStates.AVATAR) {
            const avatarQuestion = this.getAvatarOptions()
            currentScreen = <QuestionDevice question={avatarQuestion} onClick={this.selectAvatar}/>
        }

        return(
            <div>
                { currentScreen }
            </div>
        )
	}
}
        
/**************************
 * Mapping REDUX global state to local props 
 **************************/

function mapStateToProps(state) {
    return {
        currentLoginStep: state.login.currentLoginStep,
        avatarSelectionEnabled: state.login.avatarSelectionEnabled,
        avatars: state.login.avatars,
        roomCode: state.login.roomCode.code,
        biosReset: state.login.roomCode.hasError
    }
}

function mapDispatchToProps(dispatch) {
    return {
        startQuiz: bindActionCreators(startQuiz, dispatch),
        setRoomCode: bindActionCreators(setRoomCode, dispatch),
        setUserName: bindActionCreators(setUserName, dispatch),
        startAvatarSelection: bindActionCreators(startAvatarSelection, dispatch),
        resetBiosInput: bindActionCreators(resetBiosInput, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Login)


// WEBPACK FOOTER //
// ./src/components/pages/Login/Login.js